import React, { Component } from 'react';
import { Form, Button, Row, Col, Icon, Upload, message, DatePicker, Tooltip } from 'antd';
import reqwest from 'reqwest';
import moment from 'moment';
import fetch from './../services/fetch';

class LicenseForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            privateKeysFile: [],
            domain: {
            }
        }
    }

    componentDidMount() {
    }

    onSubmit() {
        event.preventDefault();
        if (!this.state.privateKeysFile[0]) {
            message.warn(`请选择秘钥文件！`)
            return
        }
        if (!this.state.domain.expiryTime) {
            message.warn(`请选择过期时间！`)
            return
        }
        this.setState({
            loading2: true
        })
        this.props.form.validateFields((error, values) => {
            if (!error) {
                const expiryTime = this.state.domain.expiryTime
                const formData = new FormData();
                formData.append('expiryTime', expiryTime);
                formData.append('privateKeysFile', this.state.privateKeysFile[0]);
                reqwest({
                    url: fetch.base + 'license/generate',
                    method: 'post',
                    processData: false,
                    data: formData,
                    success: (response) => {
                        const jsonData = JSON.parse(response)
                        setTimeout(() => {
                            this.setState({
                                loading2: false
                            })
                        }, 200);
                        if (jsonData.code == 200) {
                            console.log(jsonData.payload.data)
                            window.location.href = `${fetch.base}/license/download?licensePath=${jsonData.payload.data.licensePath}`
                        } else {
                            message.error(jsonData.message)
                            setTimeout(() => {
                                this.setState({
                                    loading2: false
                                })
                            }, 200);
                        }
                    },
                    error: (response) => {
                        message.error(`生成许可证异常！`)
                        setTimeout(() => {
                            this.setState({
                                loading2: false
                            })
                        }, 200);
                    },
                });
            } else {
                message.error(`请选择秘钥文件和过期时间！`)
            }
        })
    }

    onRemove(privateKeysFile) {
        this.setState({
            privateKeysFile: []
        });

        this.props.form.resetFields(['privateKeysFile'])
    }

    beforeUpload(privateKeysFile) {
        this.setState(state => ({
            privateKeysFile: [privateKeysFile],
        }));
        return false;
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form key={"form2"} className="license-form" layout='inline' style={{ padding: '50px 30px' }} onSubmit={this.onSubmit.bind(this)}>
                <Row span={24}>
                    <Col offset={4}>
                        <Form.Item label="密钥文件">
                            {
                                getFieldDecorator('privateKeysFile', {
                                    initialValue: '',
                                    rules: [{
                                        required: true,
                                        message: '请选择密钥文件',
                                    }],
                                })(
                                    <div>
                                        <Upload beforeUpload={this.beforeUpload.bind(this)} onRemove={this.onRemove.bind(this)} fileList={this.state.privateKeysFile}>
                                            <Button style={{ width: 180 }}>
                                                <Icon type="upload" />&nbsp;&nbsp;请选择密钥文件
                                            </Button>
                                            <span style={{ marginLeft: 10 }}>
                                                <Tooltip
                                                    placement="topLeft"
                                                    title={
                                                        <span>
                                                            <p>
                                                                秘钥文件需要开发者提供，请联系相关负责人！
                                                            </p>
                                                        </span>
                                                    }
                                                >
                                                    <Icon type="question-circle" />
                                                    &nbsp;
                                                </Tooltip>
                                            </span>
                                        </Upload>
                                    </div>
                                )
                            }
                        </Form.Item>
                    </Col>
                </Row>
                <Row span={24}>
                    <Col offset={4}>
                        <Form.Item key={'expiryTime'} label='过期时间'>
                            {getFieldDecorator('expiryTime', {
                                initialValue: this.state.domain.expiryTime ? moment(this.state.domain.expiryTime, 'YYYY-MM-DD HH:m:ss') : undefined,
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择日期!'
                                    }
                                ]
                            })
                                (<DatePicker placeholder="请选择日期"
                                    style={{ width: 180 }}
                                    onChange={(e) => {
                                        const domain = Object.assign({}, this.state.domain, {
                                            expiryTime: e
                                        })
                                        this.setState({
                                            domain
                                        })
                                    }}
                                    value={this.state.domain.expiryTime ? moment(this.state.domain.expiryTime, 'YYYY-MM-DD HH:m:ss') : undefined} format={'YYYY-MM-DD HH:m:ss'}
                                />)}
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col offset={6}>
                        <Button style={{ width: '60%', margin: '0 auto', width: 260 }} loading={this.state.loading2} size="large" htmlType="submit" type="primary">生成许可证</Button>
                    </Col>
                </Row>
            </Form>
        );
    }
}

export default Form.create()(LicenseForm);
